import {
  faLaptopCode,
  faMobileAlt,
  faBolt,
} from '@fortawesome/free-solid-svg-icons';

const servicesData = [
  {
    id: 1,
    title: 'Paginas Web',
    icon: faLaptopCode,
    description:
      'Creación de paginas web atractivas y amigables para ti o tu negocio',
  },
  {
    id: 2,
    title: 'Diseño Responsivo',
    icon: faMobileAlt,
    description:
      'Diseño adapatable a todo tamaño de pantallas para brindarte una mejor experiencia.',
  },
  {
    id: 3,
    title: 'Optimización Web',
    icon: faBolt,
    description: 'Optimizo tu sitio web para que cargue lo más rápido posible',
  },
  // {
  //   id: 4,
  //   title: 'Clean code',
  //   icon: 'fa fa-code',
  //   description:
  //     'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Mollitia qui velit numquam recusandae repellendus enim.',
  // },
  // {
  //   id: 5,
  //   title: 'SEO Marketing',
  //   icon: 'fa fa-search',
  //   description:
  //     'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Mollitia qui velit numquam recusandae repellendus enim.',
  // },
  // {
  //   id: 6,
  //   title: 'Great Support',
  //   icon: 'fa fa-bullhorn',
  //   description:
  //     'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Mollitia qui velit numquam recusandae repellendus enim.',
  // },
];

export default servicesData;
